module.exports = __webpack_public_path__ + "img/Enzymotherapy06.d77da724.jpg";